<template>
   <div class="voucher_card">
      <div class="dotted-border" v-if="voucher_cards.length === 0">
         <div class="row justify-content-md-center">
            <div class="col-12 col-md-11 col-lg-10 col-xl-9 action-card">
               <div class="btn btn-transparent btn-primary btn-round"><div :class="Model.tables.voucher_card.props.icon"></div></div>
               <div class="title">{{Model.tables.voucher_card.props.title}}</div>
               <div class="subtitle">
                  No Voucher Cards found!
               </div>
            </div>
         </div>
      </div>
      
      <Table v-bind="Model.tables.voucher_card.props" :data="voucher_cards" @on-action="handleActions"  v-if="voucher_cards.length > 0">
         <template slot-scope="{ row }" slot="expires_at">
            <strong class="tx-small">{{ dayjs(row.expires_at).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="is_paid">
            <strong class="t6 tx-success" v-if="row.is_paid">PAID</strong>
            <strong class="t6 tx-danger" v-else> NOT PAID</strong>
         </template>
         <template slot-scope="{ row }" slot="id">
            <strong class="tx-small">{{row._id}}</strong>
         </template>
         <template slot-scope="{ row }" slot="is_redeemed">
            <strong class="t6 tx-success" v-if="row.is_redeemed">REDEEMED</strong>
            <strong class="t6 tx-danger" v-else> NOT REDEEMED</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import voucher_card from "./voucher_card.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('voucher_card')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('voucher_card',voucher_card,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs,
      };
   },
   computed: {
      ...mapGetters([
         'Model',
         'voucher_cards',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchVoucherCardsForVoucher',
         'filterVouchersCards',
         'addVoucherCard',
         'deleteVoucherCard',
         'updateVoucherCard',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('voucher_card',voucher_card,this.$store)
      await this.fetchVoucherCardsForVoucher({voucher_id: this.$route.params.id})
   }
}
</script>

<style lang="scss">
   .voucher_card{
      
   }
</style>